import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

const Footer = () => {
    const { id } = useParams()
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = (page) => {
        navigate(page);
    };

    const isActive = (path) => { 
        return location.pathname === path;
    };

    return (
        <>
            <div className="appBottomMenu">
                <div className={`item ${isActive('/home') ? 'active' : ''}`} onClick={() => redirectTo('/home')}>
                    <div className="col">
                        <i className="ion-icon ri-home-3-line"></i>
                        <div className="col-name">Home</div>
                    </div>
                </div>
                <div className={`item ${isActive('/order-online') ? 'active' : ''}`} onClick={() => redirectTo('/order-online')}>
                    <div className="col">
                        <i className="ion-icon ri-bowl-line"></i>
                        <div className="col-name">Menu</div>
                    </div>
                </div>
                <div className={`item ${isActive('/catering') ? 'active' : ''}`} onClick={() => redirectTo('/catering')}>
                    <div className="col">
                        <i className="ion-icon ri-restaurant-line"></i>
                        <div className="col-name">Catering</div>
                    </div>
                </div>
                <div className={`item ${isActive('/account/orders') || isActive('/order-details/'+id) ? 'active' : ''}`} onClick={() => redirectTo('/account/orders')}>
                    <div className="col">
                    <i class="ion-icon ri-file-list-3-line"></i>
                        <div className="col-name">Orders</div>
                    </div>
                </div>
                <div className={`item ${isActive('/account') || isActive('/account/address') || isActive('/account/wallet') || isActive('/account/change-password') || isActive('/account/about-us') ? 'active' : ''}`} onClick={() => redirectTo('/account')}>
                    <div className="col">
                        <i className="ion-icon ri-user-line"></i>
                        <div className="col-name">Account</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;